<template>
  <div class="cms-input" :invalid="invalid">
    <div class="text-left">
      <label>{{fullName}}</label>
    </div>
    <div class="input-container" style="position:relative;">
      <div>
        <select @change="$emit('change', $event.target.selectedOptions[0].value)">
          <option v-if="defaultText" value="" selected disabled>{{defaultText}}</option>
          <option v-for="q in options" :key="q.value" :value="q.value">{{q.text}}</option>
        </select>
      </div>
      <cms-loader class="loader" v-if="isRemoteValidationPending"></cms-loader>
    </div>
  </div>
</template>

<script>
import validationRules from "../../mixins/validationRules";
import { mapMutations } from "vuex";

export default {
  name: "cms-input",
  mixins: [validationRules],
  props: ["options", "selected", "name", "required", "defaultText"],  
  computed: {
    fullName() {
      return this.name + ":" + (this.required ? "*" : "");
    }
  },
  methods: {}
};
</script>

<style scoped lang="scss">
div.input-container {
  height: 2rem;
  line-height: 2rem;
  position: relative;
}

label {
  color: $grey-one-color;
  padding-left: 0.7rem;
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
  margin: 0;
}

select {
  width: 100%;
  border: 0;
  padding-left: 0.7rem;
  padding-right: 0.7rem;
  appearance: none;
  outline: none;
  background-color: white;
}
</style>
